/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  GetV2PrototypesShareReviewByShareTokenParams,
  PostV2PrototypesShareReviewByShareTokenParams,
  PostV2PrototypesShareReviewFeedbackByShareTokenAndReviewIdParams,
  PostV2PrototypesShareReviewEventsByShareTokenAndReviewIdParams,
  PostV2PrototypesShareReviewFinishByShareTokenParams,
  PostV2PrototypesShareAiReviewByShareTokenParams,
  PostV2PrototypesShareAiReviewPagesChatByShareTokenAndReviewIdAndPageIdAndParentIdParams,
  PostV2PrototypesShareAiReviewPagesMessagesSystemResponseByShareTokenAndReviewIdAndPageIdAndMessageIdParams,
  PostV2PrototypesShareAiReviewFinishByShareTokenAndReviewIdParams,
  GetV2PrototypesShareByShareTokenParams,
  GetV2PrototypesShareSummaryShortByShareTokenParams,
  GetV2PrototypesShareSummaryFullByShareTokenParams,
  GetV2PrototypesShareSubscriptionInfoByShareTokenParams,
  GetV2PrototypesShareShortByShareTokenParams,
  GetV2PrototypesShareReviewsByShareTokenParams,
  GetV2PrototypesShareReviewsEventsByShareTokenAndReviewIdParams,
  GetV2PrototypesShareReviewsEventsByShareTokenParams,
  GetV2PrototypesSharePartialsByShareTokenAndPartialIdParams,
  GetV2PrototypesSharePagesByShareTokenAndPageIdParams,
  GetV2PrototypesShareAiReviewsByShareTokenParams,
  GetV2PrototypesShareAiReviewsByShareTokenAndReviewIdParams,
  GetV2PrototypesShareAiReviewsWorkspaceByShareTokenParams,
  GetV2PrototypesShareAiReviewsLatestByShareTokenParams,
  GetV2PrototypesShareAiReviewPagesChatByShareTokenAndReviewIdParams,
  GetV2PrototypesShareAiReviewPagesThreadChatByShareTokenAndPageIdAndPageThreadIdParams,
  GetV2PrototypesShareAiExtendedReviewsByShareTokenAndReviewIdParams,
  GetV2PrototypesShareAiChatMessagesConversationByShareTokenAndMessageIdParams,
  GetV2PrototypesShareReviewsByShareTokenQuery,
  GetV2PrototypesShareReviewsEventsByShareTokenAndReviewIdQuery,
  GetV2PrototypesShareReviewsEventsByShareTokenQuery,
  GetV2PrototypesShareAiReviewsLatestByShareTokenQuery,
  PostV2PrototypesShareReviewFeedbackByShareTokenAndReviewIdBody,
  PostV2PrototypesShareReviewEventsByShareTokenAndReviewIdBody,
  PostV2PrototypesShareReviewFinishByShareTokenBody,
  PostV2PrototypesShareAiReviewByShareTokenBody,
  PostV2PrototypesShareAiReviewPagesChatByShareTokenAndReviewIdAndPageIdAndParentIdBody,
  PostV2PrototypesShareAiReviewPagesMessagesSystemResponseByShareTokenAndReviewIdAndPageIdAndMessageIdBody,
  PostV2PrototypesShareAiReviewFinishByShareTokenAndReviewIdBody,
  GetV2PrototypesShareReviewByShareTokenResponse,
  PostV2PrototypesShareReviewByShareTokenResponse,
  PostV2PrototypesShareReviewFeedbackByShareTokenAndReviewIdResponse,
  PostV2PrototypesShareReviewFinishByShareTokenResponse,
  PostV2PrototypesShareAiReviewByShareTokenResponse,
  PostV2PrototypesShareAiReviewPagesChatByShareTokenAndReviewIdAndPageIdAndParentIdResponse,
  PostV2PrototypesShareAiReviewPagesMessagesSystemResponseByShareTokenAndReviewIdAndPageIdAndMessageIdResponse,
  PostV2PrototypesShareAiReviewFinishByShareTokenAndReviewIdResponse,
  GetV2PrototypesShareByShareTokenResponse,
  GetV2PrototypesShareSummaryShortByShareTokenResponse,
  GetV2PrototypesShareSummaryFullByShareTokenResponse,
  GetV2PrototypesShareSubscriptionInfoByShareTokenResponse,
  GetV2PrototypesShareShortByShareTokenResponse,
  GetV2PrototypesShareReviewsByShareTokenResponse,
  GetV2PrototypesShareReviewsEventsByShareTokenAndReviewIdResponse,
  GetV2PrototypesShareReviewsEventsByShareTokenResponse,
  GetV2PrototypesSharePartialsByShareTokenAndPartialIdResponse,
  GetV2PrototypesSharePagesByShareTokenAndPageIdResponse,
  GetV2PrototypesShareAiReviewsByShareTokenResponse,
  GetV2PrototypesShareAiReviewsByShareTokenAndReviewIdResponse,
  GetV2PrototypesShareAiReviewsWorkspaceByShareTokenResponse,
  GetV2PrototypesShareAiReviewsLatestByShareTokenResponse,
  GetV2PrototypesShareAiReviewPagesChatByShareTokenAndReviewIdResponse,
  GetV2PrototypesShareAiReviewPagesThreadChatByShareTokenAndPageIdAndPageThreadIdResponse,
  GetV2PrototypesShareAiExtendedReviewsByShareTokenAndReviewIdResponse,
  GetV2PrototypesShareAiChatMessagesConversationByShareTokenAndMessageIdResponse,
} from '../types';

export class PrototypesShare extends Controller {
  async getV2PrototypesShareReviewByShareToken<
    T extends GetV2PrototypesShareReviewByShareTokenResponse,
    D,
    C
  >(
    { shareToken }: GetV2PrototypesShareReviewByShareTokenParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/review`,
      axiosConfig
    );
  }

  async postV2PrototypesShareReviewByShareToken<
    T extends PostV2PrototypesShareReviewByShareTokenResponse,
    D,
    C extends null
  >(
    body: C,
    { shareToken }: PostV2PrototypesShareReviewByShareTokenParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/review`,
      body,
      axiosConfig
    );
  }

  async postV2PrototypesShareReviewFeedbackByShareTokenAndReviewId<
    T extends PostV2PrototypesShareReviewFeedbackByShareTokenAndReviewIdResponse,
    D,
    C extends PostV2PrototypesShareReviewFeedbackByShareTokenAndReviewIdBody
  >(
    body: C,
    {
      shareToken,
      reviewId,
    }: PostV2PrototypesShareReviewFeedbackByShareTokenAndReviewIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/review/${reviewId}/feedback`,
      body,
      axiosConfig
    );
  }

  async postV2PrototypesShareReviewEventsByShareTokenAndReviewId<
    T,
    D,
    C extends PostV2PrototypesShareReviewEventsByShareTokenAndReviewIdBody
  >(
    body: C,
    {
      shareToken,
      reviewId,
    }: PostV2PrototypesShareReviewEventsByShareTokenAndReviewIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/review/${reviewId}/events`,
      body,
      axiosConfig
    );
  }

  async postV2PrototypesShareReviewFinishByShareToken<
    T extends PostV2PrototypesShareReviewFinishByShareTokenResponse,
    D,
    C extends PostV2PrototypesShareReviewFinishByShareTokenBody
  >(
    body: C,
    { shareToken }: PostV2PrototypesShareReviewFinishByShareTokenParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/review/finish`,
      body,
      axiosConfig
    );
  }

  async postV2PrototypesShareAiReviewByShareToken<
    T extends PostV2PrototypesShareAiReviewByShareTokenResponse,
    D,
    C extends PostV2PrototypesShareAiReviewByShareTokenBody
  >(
    body: C,
    { shareToken }: PostV2PrototypesShareAiReviewByShareTokenParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/ai/review`,
      body,
      axiosConfig
    );
  }

  async postV2PrototypesShareAiReviewPagesChatByShareTokenAndReviewIdAndPageIdAndParentId<
    T extends PostV2PrototypesShareAiReviewPagesChatByShareTokenAndReviewIdAndPageIdAndParentIdResponse,
    D,
    C extends PostV2PrototypesShareAiReviewPagesChatByShareTokenAndReviewIdAndPageIdAndParentIdBody
  >(
    body: C,
    {
      shareToken,
      reviewId,
      pageId,
      parentId,
    }: PostV2PrototypesShareAiReviewPagesChatByShareTokenAndReviewIdAndPageIdAndParentIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/ai/review/${reviewId}/pages/${pageId}/${parentId}/chat`,
      body,
      axiosConfig
    );
  }

  async postV2PrototypesShareAiReviewPagesMessagesSystemResponseByShareTokenAndReviewIdAndPageIdAndMessageId<
    T extends PostV2PrototypesShareAiReviewPagesMessagesSystemResponseByShareTokenAndReviewIdAndPageIdAndMessageIdResponse,
    D,
    C extends PostV2PrototypesShareAiReviewPagesMessagesSystemResponseByShareTokenAndReviewIdAndPageIdAndMessageIdBody
  >(
    body: C,
    {
      shareToken,
      reviewId,
      pageId,
      messageId,
    }: PostV2PrototypesShareAiReviewPagesMessagesSystemResponseByShareTokenAndReviewIdAndPageIdAndMessageIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/ai/review/${reviewId}/pages/${pageId}/messages/${messageId}/system/response`,
      body,
      axiosConfig
    );
  }

  async postV2PrototypesShareAiReviewFinishByShareTokenAndReviewId<
    T extends PostV2PrototypesShareAiReviewFinishByShareTokenAndReviewIdResponse,
    D,
    C extends PostV2PrototypesShareAiReviewFinishByShareTokenAndReviewIdBody
  >(
    body: C,
    {
      shareToken,
      reviewId,
    }: PostV2PrototypesShareAiReviewFinishByShareTokenAndReviewIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/ai/review/${reviewId}/finish`,
      body,
      axiosConfig
    );
  }

  async getV2PrototypesShareByShareToken<
    T extends GetV2PrototypesShareByShareTokenResponse,
    D,
    C
  >(
    { shareToken }: GetV2PrototypesShareByShareTokenParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}`,
      axiosConfig
    );
  }

  async getV2PrototypesShareSummaryShortByShareToken<
    T extends GetV2PrototypesShareSummaryShortByShareTokenResponse,
    D,
    C
  >(
    { shareToken }: GetV2PrototypesShareSummaryShortByShareTokenParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/summary/short`,
      axiosConfig
    );
  }

  async getV2PrototypesShareSummaryFullByShareToken<
    T extends GetV2PrototypesShareSummaryFullByShareTokenResponse,
    D,
    C
  >(
    { shareToken }: GetV2PrototypesShareSummaryFullByShareTokenParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/summary/full`,
      axiosConfig
    );
  }

  async getV2PrototypesShareSubscriptionInfoByShareToken<
    T extends GetV2PrototypesShareSubscriptionInfoByShareTokenResponse,
    D,
    C
  >(
    { shareToken }: GetV2PrototypesShareSubscriptionInfoByShareTokenParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/subscription-info`,
      axiosConfig
    );
  }

  async getV2PrototypesShareShortByShareToken<
    T extends GetV2PrototypesShareShortByShareTokenResponse,
    D,
    C
  >(
    { shareToken }: GetV2PrototypesShareShortByShareTokenParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/short`,
      axiosConfig
    );
  }

  async getV2PrototypesShareReviewsByShareToken<
    T extends GetV2PrototypesShareReviewsByShareTokenResponse,
    D,
    C
  >(
    { shareToken }: GetV2PrototypesShareReviewsByShareTokenParams,
    query: GetV2PrototypesShareReviewsByShareTokenQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl(`/v2/prototypes/share/${shareToken}/reviews`, query),
      axiosConfig
    );
  }

  async getV2PrototypesShareReviewsEventsByShareTokenAndReviewId<
    T extends GetV2PrototypesShareReviewsEventsByShareTokenAndReviewIdResponse,
    D,
    C
  >(
    {
      shareToken,
      reviewId,
    }: GetV2PrototypesShareReviewsEventsByShareTokenAndReviewIdParams,
    query: GetV2PrototypesShareReviewsEventsByShareTokenAndReviewIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl(
        `/v2/prototypes/share/${shareToken}/reviews/${reviewId}/events`,
        query
      ),
      axiosConfig
    );
  }

  async getV2PrototypesShareReviewsEventsByShareToken<
    T extends GetV2PrototypesShareReviewsEventsByShareTokenResponse,
    D,
    C
  >(
    { shareToken }: GetV2PrototypesShareReviewsEventsByShareTokenParams,
    query: GetV2PrototypesShareReviewsEventsByShareTokenQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl(
        `/v2/prototypes/share/${shareToken}/reviews/events`,
        query
      ),
      axiosConfig
    );
  }

  async getV2PrototypesSharePartialsByShareTokenAndPartialId<
    T extends GetV2PrototypesSharePartialsByShareTokenAndPartialIdResponse,
    D,
    C
  >(
    {
      shareToken,
      partialId,
    }: GetV2PrototypesSharePartialsByShareTokenAndPartialIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/partials/${partialId}`,
      axiosConfig
    );
  }

  async getV2PrototypesSharePagesByShareTokenAndPageId<
    T extends GetV2PrototypesSharePagesByShareTokenAndPageIdResponse,
    D,
    C
  >(
    {
      shareToken,
      pageId,
    }: GetV2PrototypesSharePagesByShareTokenAndPageIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/pages/${pageId}`,
      axiosConfig
    );
  }

  async getV2PrototypesShareAiReviewsByShareToken<
    T extends GetV2PrototypesShareAiReviewsByShareTokenResponse,
    D,
    C
  >(
    { shareToken }: GetV2PrototypesShareAiReviewsByShareTokenParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/ai/reviews`,
      axiosConfig
    );
  }

  async getV2PrototypesShareAiReviewsByShareTokenAndReviewId<
    T extends GetV2PrototypesShareAiReviewsByShareTokenAndReviewIdResponse,
    D,
    C
  >(
    {
      shareToken,
      reviewId,
    }: GetV2PrototypesShareAiReviewsByShareTokenAndReviewIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/ai/reviews/${reviewId}`,
      axiosConfig
    );
  }

  async getV2PrototypesShareAiReviewsWorkspaceByShareToken<
    T extends GetV2PrototypesShareAiReviewsWorkspaceByShareTokenResponse,
    D,
    C
  >(
    { shareToken }: GetV2PrototypesShareAiReviewsWorkspaceByShareTokenParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/ai/reviews/workspace`,
      axiosConfig
    );
  }

  async getV2PrototypesShareAiReviewsLatestByShareToken<
    T extends GetV2PrototypesShareAiReviewsLatestByShareTokenResponse,
    D,
    C
  >(
    { shareToken }: GetV2PrototypesShareAiReviewsLatestByShareTokenParams,
    query: GetV2PrototypesShareAiReviewsLatestByShareTokenQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl(
        `/v2/prototypes/share/${shareToken}/ai/reviews/latest`,
        query
      ),
      axiosConfig
    );
  }

  async getV2PrototypesShareAiReviewPagesChatByShareTokenAndReviewId<
    T extends GetV2PrototypesShareAiReviewPagesChatByShareTokenAndReviewIdResponse,
    D,
    C
  >(
    {
      shareToken,
      reviewId,
    }: GetV2PrototypesShareAiReviewPagesChatByShareTokenAndReviewIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/ai/review/${reviewId}/pages/chat`,
      axiosConfig
    );
  }

  async getV2PrototypesShareAiReviewPagesThreadChatByShareTokenAndPageIdAndPageThreadId<
    T extends GetV2PrototypesShareAiReviewPagesThreadChatByShareTokenAndPageIdAndPageThreadIdResponse,
    D,
    C
  >(
    {
      shareToken,
      pageId,
      pageThreadId,
    }: GetV2PrototypesShareAiReviewPagesThreadChatByShareTokenAndPageIdAndPageThreadIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/ai/review/pages/${pageId}/thread/${pageThreadId}/chat`,
      axiosConfig
    );
  }

  async getV2PrototypesShareAiExtendedReviewsByShareTokenAndReviewId<
    T extends GetV2PrototypesShareAiExtendedReviewsByShareTokenAndReviewIdResponse,
    D,
    C
  >(
    {
      shareToken,
      reviewId,
    }: GetV2PrototypesShareAiExtendedReviewsByShareTokenAndReviewIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/ai/extended/reviews/${reviewId}`,
      axiosConfig
    );
  }

  async getV2PrototypesShareAiChatMessagesConversationByShareTokenAndMessageId<
    T extends GetV2PrototypesShareAiChatMessagesConversationByShareTokenAndMessageIdResponse,
    D,
    C
  >(
    {
      shareToken,
      messageId,
    }: GetV2PrototypesShareAiChatMessagesConversationByShareTokenAndMessageIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/share/${shareToken}/ai/chat/messages/${messageId}/conversation`,
      axiosConfig
    );
  }
}
